<template>
  <div class="file">
    <div class="file-list-title" :class="{ line: config.topLine }">
      <h3 class="list-title-txt" :class="{ bold: config.bold }">
        {{ config.title }}
      </h3>
      <div class="list-more" v-if="config.more">
        <div class="list-more-txt">{{ config.more.title }}</div>
        <a-icon type="right" />
      </div>
    </div>
    <ul class="m-file-list">
      <li
        class="m-file-item"
        :class="{ line: config.itemLine }"
        :style="contentStyle"
        v-for="(a, i) in config.list"
        :key="i"
      >
        <!-- <div class="file-avatar">
          <a-icon type="file-text" />
        </div> -->
        <div class="file-txt">
          <div class="file-name">{{ a.name }}</div>
          <a-icon type="download" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getDistance } from "../../common/js/tool";

export default {
  name: "file-list",
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    contentStyle() {
      let content = this.config.content;
      let style = {};
      if (content.padding) {
        style.padding = getDistance(content.padding);
      }
      // if (content.borderRadius) {
      //   style.borderRadius = content.borderRadius + "px";
      // }
      if (content.backgroundColor) {
        style.backgroundColor = content.backgroundColor;
      }
      return style;
    },
  },
};
</script>

<style scoped lang="less">
.file {
  --light-font-color: #c0c4cc;
  --tip-font-color: #909399;
}
.file-list-title {
  display: flex;
  align-items: center;
  &.line {
    border-bottom: var(--border);
  }
}
.list-title-txt {
  margin: 0;
  flex: 1;
  height: 36px;
  line-height: 36px;
  &.bold {
    font-weight: 600;
  }
}
.list-more {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: var(--light-font-color);
}
.m-file-list {
  padding: 10px 0;
}
.m-file-item {
  display: flex;
  &.line:not(:last-of-type) {
    border-bottom: var(--border);
  }
  &:first-of-type {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:last-of-type {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
.file-avatar {
  flex-shrink: 0;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  color: #ccc;
  text-align: center;
  font-size: 18px;
}
.file-txt {
  flex: 1;
  color: var(--title-font-color);
  line-height: 1.5;
  font-size: 14px;
  display: flex;
  align-items: center;
  .file-name {
    flex: 1;
  }
  span {
    float: right;
    margin-right: 25px;
    font-size: 16px;
    color: white;
    background-color: #ccc;
  }
}
.file-duty {
  margin-top: 6px;
  font-size: 12px;
}
</style>
